import React, { useState } from "react"
import styles from "../styles/global.module.scss"

export default function FeedbackForm() {
  // Initialize local state
  let [localState, setLocalState] = useState({
    birthday: "",
    email: "",
    message: "",
    experience: "",
    feedback: "",
    name: "",
    phone: "",
  })

  // Update state on form field change
  const onChange = e => {
    setLocalState({
      ...localState,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <form
      className={styles.primaryForm}
      name="FeedbackForm"
      method="POST"
      netlify-honeypot="bot-field"
      data-netlify="true"
      action="/thank-you/"
    >
      <input type="hidden" name="form-name" value="FeedbackForm" />
      <input type="hidden" name="bot-field" />
      <div className={styles.flexWrapper}>
        <div className={styles.formItem}>
          <label htmlFor="name">Name </label>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
          />
        </div>
        <div className={styles.formItem}>
          <label htmlFor="email">Email </label>
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
          />
        </div>
      </div>
      <div className={styles.flexWrapper}>
        <div className={styles.formItem}>
          <label htmlFor="phone">Phone </label>
          <input
            type="phone"
            name="phone"
            placeholder="Phone Number"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
          />
        </div>
        <div className={styles.formItem}>
          <label htmlFor="company">Birthday </label>
          <input
            type="text"
            name="company"
            placeholder="Month / Day"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
          />
        </div>
      </div>
      <div className={styles.formItem}>
        <label htmlFor="message">How did you hear about us? </label>
        <textarea
          name="message"
          placeholder="Let us know how you found us."
          rows="2"
          cols="50"
          onBlur={e => onChange(e)}
          onChange={e => onChange(e)}
        />
      </div>
      <div className={styles.formItem}>
        <label htmlFor="experience">How was your experience? </label>
        <textarea
          name="experience"
          placeholder="Let us know if you were satisfied with your experience."
          rows="4"
          cols="50"
          onBlur={e => onChange(e)}
          onChange={e => onChange(e)}
        />
      </div>
      <div className={styles.formItem}>
        <label htmlFor="feedback">Any feedback? </label>
        <textarea
          name="feedback"
          placeholder="If you are satisfied with our work or think we can do something better, let us know!"
          rows="4"
          cols="50"
          onBlur={e => onChange(e)}
          onChange={e => onChange(e)}
        />
      </div>
      <div className={styles.buttonContain}>
        <button className={styles.btn} type="submit" aria-label="Submit Form">
          Submit
        </button>
      </div>
    </form>
  )
}
